import { AfterViewInit, Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the TreeViewDetailModalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-tree-view-detail-modal',
  templateUrl: 'tree-view-detail-modal.html',
  inputs: ['selectedRow']
})
export class TreeViewDetailModalPage implements AfterViewInit {

  selectedRow: any;
  isModal: boolean = false;

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ngAfterViewInit(): void {
    console.log(this.selectedRow);
  }

  ionViewDidLoad() {
    if(this.navParams.get('selectedRow') != undefined) {
      this.selectedRow = this.navParams.get('selectedRow');
      this.isModal = true;
    }
    console.log('ionViewDidLoad TreeViewDetailModalPage');
  }

  close() {
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/tree-view-detail-modal/tree-view-detail-modal.ts